import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Switch as EvergreenSwitch } from 'evergreen-ui';
import cn from 'classnames';

import styles from './styles.module.css';

const Switch = ({
  className,
  checked,
  onChange,
  disabled,
}) => {
  const onSwitchChange = useCallback((e) => {
    onChange?.(e.target.checked);
  }, [onChange]);

  return (
    <EvergreenSwitch
      className={cn(
        styles.switch,
        className,
      )}
      checked={checked}
      onChange={onSwitchChange}
      disabled={disabled}
    />
  );
};

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Switch.defaultProps = {
  disabled: false,
  className: null,
};

export default React.memo(Switch);
